import {RegistrationPaymentMethod} from './paymentMethod';

export type PaymentSubStep =
	| 'select'
	| 'sbp_phone'
	| 'sbp_bank'
	| 'sbp_review'
	| 'card_number'
	| 'card_review'
	| 'account_bik'
	| 'account_number'
	| 'account_review';

export const PAYMENT_ACCOUNT_INVALID_MESSAGE = 'Неверный номер счёта';
export const PAYMENT_BIK_NOT_FOUND_MESSAGE = 'Ничего не нашли';
export const PAYMENT_CARD_COMMISSION_VALUE = '0,5%';
export const PAYMENT_CARD_COMMISSION_HINT =
	'С каждой выплаты на карту берётся комиссия за нашу работу';

export const getInitialPaymentSubStep = (method: RegistrationPaymentMethod): PaymentSubStep => {
	switch (method) {
		case 'sbp_account':
			return 'sbp_phone';
		case 'bank_card':
			return 'card_number';
		case 'executor_account':
			return 'account_bik';
		default:
			return 'select';
	}
};

export const getPreviousPaymentSubStep = (
	method: RegistrationPaymentMethod,
	subStep: PaymentSubStep,
): PaymentSubStep | 'select' => {
	switch (subStep) {
		case 'sbp_phone':
		case 'card_number':
		case 'account_bik':
			return 'select';
		case 'card_review':
			return 'card_number';
		case 'sbp_bank':
			return 'sbp_phone';
		case 'sbp_review':
			return 'sbp_bank';
		case 'account_number':
			return 'account_bik';
		case 'account_review':
			return 'account_number';
		default:
			return 'select';
	}
};

/** Порядок под-шагов внутри выбранного способа оплаты (для пагинации). */
export const getPaymentSubStepSequence = (method: RegistrationPaymentMethod): PaymentSubStep[] => {
	switch (method) {
		case 'sbp_account':
			return ['sbp_phone', 'sbp_bank', 'sbp_review'];
		case 'bank_card':
			return ['card_number', 'card_review'];
		case 'executor_account':
			return ['account_bik', 'account_number', 'account_review'];
		default:
			return [];
	}
};

/** Пагинация под-флоу оплаты: у ИП «БИК → Счёт → Подтверждение» = 1/3, 2/3, 3/3. */
export const getPaymentSubStepProgress = (
	method: RegistrationPaymentMethod,
	subStep: PaymentSubStep,
	prefixSteps = 0,
): {currentStep: number; totalSteps: number} | null => {
	const sequence = getPaymentSubStepSequence(method);
	const index = sequence.indexOf(subStep);

	if (index < 0) {
		return null;
	}

	return {currentStep: prefixSteps + index, totalSteps: prefixSteps + sequence.length};
};

export const getContinueButtonLabel = (subStep: PaymentSubStep): string => {
	if (subStep === 'sbp_review' || subStep === 'account_review' || subStep === 'card_review') {
		return 'Всё верно';
	}

	return 'Продолжить';
};
